// // const config = {
// //     encryptionkey:"lemrcccpredictor",
// //     aliasWWIDName: 'lsMainKey',
// //     ssoURL: 'https://lemrcccpredictor.jnj.com/sso/',
// //   }
// //   export default config;

const config = {
  encryptionkey: "lemrcccpredictor",
  // aliasWWIDName: "lsMainKey",
  // ssoURL: "https://dvl.lemrcccpredictor.jnj.com",
};
export default config;

// import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENTID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENENTID}`,
    redirectUri: process.env.REACT_APP_REDIRECTURL,
    // postLogoutRedirectUri: "/",
  },
  cache: {
    // cacheLocation: "sessionStorage", // This configures where your cache will be stored
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  // system: {
  //   loggerOptions: {
  //     loggerCallback: (level, message, containsPii) => {
  //       if (containsPii) {
  //         return;
  //       }
  //       switch (level) {
  //         case LogLevel.Error:
  //           console.error(message);
  //           return;
  //         case LogLevel.Info:
  //           console.info(message);
  //           return;
  //         case LogLevel.Verbose:
  //           console.debug(message);
  //           return;
  //         case LogLevel.Warning:
  //           console.warn(message);
  //           return;
  //         default:
  //           return;
  //       }
  //     },
  //   },
  // },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read"],
};

const logoutRequest = {
  // account: myMsal.getAccountByHomeId(homeAccountId),
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
